// extracted by mini-css-extract-plugin
module.exports = {"alerts":"styles_alerts__2btUY"};